import React, { useState, useEffect, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import CircularLoading from "../components/CircularLoading";
import { api } from "common";
import { makeStyles } from "@mui/styles";
import { useTranslation } from "react-i18next";
import { Modal, Grid, Typography, useMediaQuery, Switch, TextField, IconButton, Card, Button } from "@mui/material";
import CancelIcon from "@mui/icons-material/Cancel";
import AlertDialog from "../components/AlertDialog";
import CircularProgress from "@mui/material/CircularProgress";
import Tooltip from "@mui/material/Tooltip";
import moment from "moment/min/moment-with-locales";
import { useNavigate } from "react-router-dom";
import EditIcon from '@mui/icons-material/Edit';
import SearchIcon from '@mui/icons-material/Search';
import ClearIcon from '@mui/icons-material/Clear';
import DownloadIcon from '@mui/icons-material/Download';
import DeleteIcon from '@mui/icons-material/Delete';

const useStyles = makeStyles((theme) => ({
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  submit3: {
    width: "100%",
    borderRadius: 3,
    marginTop: 2,
    padding: 4,
  },
  paper: {
    width: 500,
    backgroundColor: "var(--bg-card) !important",
    border: "var(--card-border)",
    boxShadow: "var(--shadow)",
    padding: theme.spacing(2, 4, 3),
    borderRadius: 15,
    alignItems: "center",
    justifyContent: "center",
    color: "var(--text-main)"
  },
  searchField: {
    "& .MuiOutlinedInput-root": {
      borderRadius: "12px !important",
      backgroundColor: "var(--bg-card) !important",
      color: "var(--text-main) !important",
      border: "var(--card-border) !important",
      "& fieldset": {
        border: "none !important"
      },
      "&.Mui-focused": {
        border: "1px solid #E9AE31 !important"
      }
    }
  },
}));

export default function CarsList() {
  const { t, i18n } = useTranslation();
  const isRTL = i18n.dir();
  const settings = useSelector((state) => state.settingsdata.settings);
  const userdata = useSelector((state) => state.usersdata);
  const auth = useSelector((state) => state.auth);
  const [drivers, setDrivers] = useState([]);
  const { updateUserCar, editCar } = api;
  const [driversObj, setDriversObj] = useState();
  const [data, setData] = useState([]);
  const carlistdata = useSelector((state) => state.carlistdata);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const rootRef = useRef(null);
  const classes = useStyles();
  const [role, setRole] = useState(null);


  useEffect(() => {
    if (role !== "driver" && userdata.users) {
      let arr = userdata.users.filter(
        (user) =>
          user.usertype === "driver" &&
          ((role === "fleetadmin" &&
            user.fleetadmin &&
            user.fleetadmin === auth.profile.uid) ||
            role === "admin")
      );
      let obj = {};
      let obj2 = {};
      let arr2 = [];
      for (let i = 0; i < arr.length; i++) {
        let user = arr[i];
        arr2.push({
          id: user.id,
          desc:
            user.firstName +
            " " +
            user.lastName +
            " (" +
            (settings.AllowCriticalEditsAdmin ? user.mobile : t("hidden_demo")) +
            ") " +
            (settings.AllowCriticalEditsAdmin ? user.email : t("hidden_demo")),
        });
        obj[user.id] =
          user.firstName +
          " " +
          user.lastName +
          " (" +
          (settings.AllowCriticalEditsAdmin ? user.mobile : t("hidden_demo")) +
          ") " +
          (settings.AllowCriticalEditsAdmin ? user.email : t("hidden_demo"));
        obj2[user.id] = user.fleetadmin ? user.fleetadmin : null;
      }
      setDrivers(arr2);
      setDriversObj(obj);
    }
  }, [
    userdata.users,
    settings.AllowCriticalEditsAdmin,
    role,
    auth.profile.uid, t
  ]);


  useEffect(() => {
    if (auth.profile && auth.profile.usertype) {
      setRole(auth.profile.usertype);
    }
  }, [auth.profile]);

  useEffect(() => {
    if (carlistdata.cars) {
      setData(carlistdata.cars);
    } else {
      setData([]);
    }
  }, [carlistdata.cars]);

  const [selectedImage, setSelectedImage] = useState(null);
  const handleProfileModal = (e) => {
    setProfileModal(false);
    setSelectedImage(null);
  };

  const [userData, setUserData] = useState();
  const [profileModal, setProfileModal] = useState(false);
  const [imageData, setImageData] = useState(false);
  const [commonAlert, setCommonAlert] = useState({ open: false, msg: "" });
  const [loading, setLoading] = useState(false);

  const handleCommonAlertClose = (e) => {
    e.preventDefault();
    setCommonAlert({ open: false, msg: "" });
  };

  const handleSetProfileModal = (e) => {
    e.preventDefault();
    if (settings.AllowCriticalEditsAdmin) {
      if (selectedImage) {
        setLoading(true);
        let finalData = userData;
        finalData.car_image = selectedImage;
        dispatch(editCar(finalData, "UpdateImage"));
        setProfileModal(false);
        setTimeout(() => {
          setSelectedImage(null);
          setLoading(false);
        }, 10000);
      } else {
        setCommonAlert({ open: true, msg: t("choose_image_first") });
      }

    } else {
      setCommonAlert({ open: true, msg: t('demo_mode') })
    }
  }

  const onClick = (rowData) => {
    setImageData(rowData.car_image);
    setProfileModal(true);
    setUserData(rowData);
  };

  const [searchQuery, setSearchQuery] = useState("");
  const [page, setPage] = useState(0);
  const [deleteConfirmOpen, setDeleteConfirmOpen] = useState(false);
  const [carToDelete, setCarToDelete] = useState(null);
  const isMidScreen = useMediaQuery('(max-width:991px)');
  const rowsPerPage = 5;

  const filteredData = data.filter((car) => {
    const regNo = (car.vehicleNumber || "").toLowerCase();
    const make = (car.vehicleMake || "").toLowerCase();
    const model = (car.vehicleModel || "").toLowerCase();
    const type = (car.carType || "").toLowerCase();
    const driverNameStr = car.driver ? (driversObj && driversObj[car.driver] ? driversObj[car.driver].toLowerCase() : "") : "";
    const query = searchQuery.toLowerCase();
    return regNo.includes(query) || make.includes(query) || model.includes(query) || type.includes(query) || driverNameStr.includes(query);
  });

  const paginatedData = filteredData.slice(page * rowsPerPage, (page + 1) * rowsPerPage);

  const handleDeleteClick = (car) => {
    if (car.active) {
      alert(t("active_car_delete"));
    } else {
      setCarToDelete(car);
      setDeleteConfirmOpen(true);
    }
  };

  const handleExport = () => {
    const headers = [t("createdAt"), t("driver"), t("car_type"), t("vehicle_reg_no"), t("vehicle_model_name"), t("vehicle_model_no"), t("other_info"), t("active_status"), t("approved")];
    const rows = filteredData.map(car => [
      car.createdAt ? moment(car.createdAt).format("lll") : "",
      car.driver ? (driversObj && driversObj[car.driver] ? driversObj[car.driver] : "") : "",
      car.carType || "",
      car.vehicleNumber || "",
      car.vehicleMake || "",
      car.vehicleModel || "",
      car.other_info || "",
      car.active ? "Active" : "Inactive",
      car.approved ? "Approved" : "Pending"
    ]);

    let csvContent = "data:text/csv;charset=utf-8,\uFEFF" 
      + [headers.join(","), ...rows.map(e => e.map(val => `"${val.replace(/"/g, '""')}"`).join(","))].join("\n");
    
    const encodedUri = encodeURI(csvContent);
    const link = document.createElement("a");
    link.setAttribute("href", encodedUri);
    link.setAttribute("download", `cars_list_${moment().format("YYYY-MM-DD")}.csv`);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };
  const handelApproved = (rowData) => {
    if (settings.carApproval && role === "admin") {
      dispatch(
        updateUserCar(rowData.driver, {
          carApproved: !rowData.approved,
        })
      );
      dispatch(editCar({ ...rowData, approved: !rowData.approved }, "Update"));
    }
  };

  const handleActiveToggle = (car) => {
    if (settings.AllowCriticalEditsAdmin || role === "driver" || role === "fleetadmin") {
      const newActiveState = !car.active;
      
      if (newActiveState) {
        let activeCar = null;
        for (let i = 0; i < data.length; i++) {
          if (data[i].driver === car.driver && data[i].active && data[i].id !== car.id) {
            activeCar = data[i];
            break;
          }
        }
        
        let updateData = {
          carType: car.carType,
          vehicleNumber: car.vehicleNumber,
          vehicleMake: car.vehicleMake,
          vehicleModel: car.vehicleModel,
          other_info: car.other_info,
          car_image: car.car_image,
          updateAt: new Date().getTime()
        };

        if (activeCar) {
          dispatch(editCar({ ...activeCar, active: false }, "Update"));
        }
        
        dispatch(editCar({ ...car, active: true }, "Update"));
        dispatch(updateUserCar(car.driver, updateData));
      } else {
        dispatch(editCar({ ...car, active: false }, "Update"));
        dispatch(updateUserCar(car.driver, {
          carType: null,
          vehicleNumber: null,
          vehicleMake: null,
          vehicleModel: null,
          other_info: null,
          car_image: null,
          updateAt: new Date().getTime()
        }));
      }
    } else {
      alert(t("demo_mode"));
    }
  };

  return carlistdata.loading ? (
    <CircularLoading />
  ) : (
    <div className="responsive-container" style={{ backgroundColor: 'var(--bg-main)', minHeight: '100vh' }}>
      
      {/* Upper header action section */}
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '24px', flexWrap: 'wrap', gap: '16px' }}>
        <div>
          <Typography variant="h4" style={{ fontWeight: 700, color: 'var(--text-main)', fontFamily: 'Outfit, sans-serif' }}>
            {t("cars_title")}
          </Typography>
          <Typography variant="body2" style={{ color: 'var(--text-secondary)', marginTop: '4px' }}>
            {t("manage_your_cars") || "Manage and view all your registered vehicles."}
          </Typography>
        </div>
        <Button
          onClick={() => navigate(`/cars/editcar`)}
          variant="contained"
          style={{
            background: 'linear-gradient(135deg, #E9AE31 0%, #c58d1b 100%)',
            color: '#08080A',
            borderRadius: '12px',
            fontWeight: 700,
            textTransform: 'none',
            padding: '10px 24px',
            boxShadow: '0 4px 12px rgba(233, 174, 49, 0.25)',
            border: 'none',
            fontFamily: 'Outfit, sans-serif'
          }}
          sx={{
            transition: 'all 0.2s ease-in-out',
            '&:hover': {
              transform: 'translateY(-2px)',
              boxShadow: '0 6px 20px rgba(233, 174, 49, 0.4)'
            }
          }}
        >
          {t("add_car")}
        </Button>
      </div>

      {/* Search and Filters Section */}
      <div style={{ display: 'flex', gap: '16px', marginBottom: '24px', flexWrap: 'wrap', alignItems: 'center' }}>
        <TextField
          placeholder={t("search") || "Search cars..."}
          value={searchQuery}
          onChange={(e) => {
            setSearchQuery(e.target.value);
            setPage(0);
          }}
          style={{ flex: 1, minWidth: '280px' }}
          className={classes.searchField}
          InputProps={{
            startAdornment: (
              <SearchIcon style={{ color: 'var(--text-secondary)', marginRight: '8px' }} />
            ),
            endAdornment: searchQuery ? (
              <IconButton onClick={() => { setSearchQuery(""); setPage(0); }} size="small">
                <ClearIcon style={{ color: 'var(--text-secondary)' }} />
              </IconButton>
            ) : null
          }}
        />
        <Button
          onClick={handleExport}
          variant="outlined"
          style={{
            borderColor: 'var(--border-color)',
            color: 'var(--text-main)',
            borderRadius: '12px',
            textTransform: 'none',
            fontWeight: 600,
            padding: '10px 20px',
            display: 'flex',
            alignItems: 'center',
            gap: '8px'
          }}
        >
          <DownloadIcon style={{ fontSize: '20px' }} />
          {t("export") || "Export"}
        </Button>
      </div>

      <div ref={rootRef}>
        {filteredData.length > 0 ? (
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            {paginatedData.map((car) => {
              const driverName = car.driver ? (driversObj && driversObj[car.driver] ? driversObj[car.driver] : t("no_driver")) : t("no_driver");
              return (
                <Card
                  key={car.id}
                  style={{
                    borderRadius: "20px",
                    backgroundColor: "var(--bg-card)",
                    color: "var(--text-main)",
                    border: "var(--card-border)",
                    padding: "20px",
                    marginBottom: "20px",
                    boxShadow: "var(--shadow)",
                    display: "flex",
                    flexDirection: isMidScreen ? "column" : "row",
                    gap: "24px",
                    position: "relative",
                    transition: "all 0.3s ease",
                  }}
                  sx={{
                    '&:hover': {
                      boxShadow: 'var(--shadow-neon)',
                      transform: 'translateY(-2px)'
                    }
                  }}
                >
                  {/* Left: Car Image with Edit Overlay */}
                  <div 
                    style={{ 
                      width: isMidScreen ? "100%" : "200px", 
                      height: "150px", 
                      borderRadius: "16px", 
                      overflow: "hidden", 
                      position: "relative",
                      backgroundColor: "rgba(0,0,0,0.2)",
                      border: "1px solid rgba(255,255,255,0.05)"
                    }}
                  >
                    <img 
                      src={car.car_image || "https://cdn.pixabay.com/photo/2012/04/13/20/37/car-33556__480.png"} 
                      alt="Car" 
                      style={{ width: "100%", height: "100%", objectFit: "cover" }}
                    />
                    <button
                      onClick={() => onClick(car)}
                      style={{
                        position: "absolute",
                        inset: 0,
                        background: "rgba(0, 0, 0, 0.5)",
                        border: "none",
                        color: "#ffffff",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        cursor: "pointer",
                        opacity: 0,
                        transition: "opacity 0.2s ease",
                        fontWeight: 600,
                        fontFamily: 'Outfit, sans-serif'
                      }}
                      onMouseEnter={(e) => e.target.style.opacity = 1}
                      onMouseLeave={(e) => e.target.style.opacity = 0}
                    >
                      {t("upload_car_image")}
                    </button>
                  </div>

                  {/* Middle: Details */}
                  <div style={{ flex: 1, display: "flex", flexDirection: "column", gap: "12px" }}>
                    <div style={{ display: "flex", alignItems: "center", gap: "12px", flexWrap: "wrap" }}>
                      <Typography variant="h5" style={{ fontWeight: 700, fontFamily: "Outfit, sans-serif", color: "#E9AE31" }}>
                        {car.vehicleMake} {car.vehicleModel}
                      </Typography>
                      <div style={{ display: "flex", gap: "8px" }}>
                        <span style={{ 
                          fontSize: "12px", 
                          fontWeight: 600, 
                          padding: "4px 10px", 
                          borderRadius: "999px", 
                          border: "1px solid rgba(233, 174, 49, 0.4)", 
                          color: "#E9AE31",
                          backgroundColor: "rgba(233, 174, 49, 0.05)" 
                        }}>
                          {car.carType}
                        </span>
                        <span style={{ 
                          fontSize: "12px", 
                          fontWeight: 600, 
                          padding: "4px 10px", 
                          borderRadius: "999px", 
                          border: "1px solid var(--border-color)", 
                          color: "var(--text-secondary)",
                          backgroundColor: "rgba(255,255,255,0.02)" 
                        }}>
                          {car.vehicleNumber}
                        </span>
                      </div>
                    </div>

                    <Grid container spacing={2} style={{ marginTop: "4px" }}>
                      <Grid item xs={12} sm={6}>
                        <Typography variant="body2" style={{ color: "var(--text-secondary)" }}>
                          <strong>{t("driver")}:</strong> {driverName}
                        </Typography>
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <Typography variant="body2" style={{ color: "var(--text-secondary)" }}>
                          <strong>{t("createdAt")}:</strong> {car.createdAt ? moment(car.createdAt).format("lll") : ""}
                        </Typography>
                      </Grid>
                      {car.other_info && (
                        <Grid item xs={12}>
                          <Typography variant="body2" style={{ color: "var(--text-secondary)" }}>
                            <strong>{t("other_info")}:</strong> {car.other_info}
                          </Typography>
                        </Grid>
                      )}
                    </Grid>
                  </div>

                  {/* Right: Statuses & Action Buttons */}
                  <div style={{ 
                    width: isMidScreen ? "100%" : "240px", 
                    display: "flex", 
                    flexDirection: "column", 
                    justifyContent: "space-between", 
                    alignItems: isMidScreen ? "flex-start" : "flex-end",
                    gap: "16px",
                    borderLeft: isMidScreen ? "none" : "1px solid var(--border-color)",
                    paddingLeft: isMidScreen ? 0 : "24px",
                    marginTop: isMidScreen ? "12px" : 0
                  }}>
                    <div style={{ display: "flex", flexDirection: "column", gap: "8px", alignItems: isMidScreen ? "flex-start" : "flex-end" }}>
                      {/* Active Status Toggle */}
                      <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                        <Typography variant="body2" style={{ color: "var(--text-secondary)", fontWeight: 500 }}>
                          {t("active") || "Active"}:
                        </Typography>
                        <Switch
                          size="small"
                          checked={car.active}
                          onChange={() => handleActiveToggle(car)}
                          disabled={role === "driver" && car.driver !== auth.profile.uid}
                          sx={{
                            '& .MuiSwitch-switchBase.Mui-checked': {
                              color: '#E9AE31',
                            },
                            '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
                              backgroundColor: '#E9AE31',
                            }
                          }}
                        />
                      </div>

                      {/* Approval Toggle or Badge */}
                      {settings.carApproval && role === "admin" ? (
                        <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                          <Typography variant="body2" style={{ color: "var(--text-secondary)", fontWeight: 500 }}>
                            {t("approved")}:
                          </Typography>
                          <Switch
                            size="small"
                            checked={car.approved}
                            onChange={() => handelApproved(car)}
                            disabled={!settings.AllowCriticalEditsAdmin}
                            sx={{
                              '& .MuiSwitch-switchBase.Mui-checked': {
                                color: '#E9AE31',
                              },
                              '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
                                backgroundColor: '#E9AE31',
                              }
                            }}
                          />
                        </div>
                      ) : (
                        <span style={{ 
                          fontSize: "12px", 
                          fontWeight: 600, 
                          padding: "4px 10px", 
                          borderRadius: "4px", 
                          backgroundColor: car.approved ? "rgba(16, 185, 129, 0.1)" : "rgba(239, 68, 68, 0.1)",
                          color: car.approved ? "#10b981" : "#ef4444",
                          border: car.approved ? "1px solid rgba(16, 185, 129, 0.2)" : "1px solid rgba(239, 68, 68, 0.2)"
                        }}>
                          {car.approved ? t("approved") : t("pending") || "Pending"}
                        </span>
                      )}
                    </div>

                    {/* Actions */}
                    <div style={{ display: "flex", gap: "12px", width: "100%", justifyContent: isMidScreen ? "flex-start" : "flex-end" }}>
                      <Button
                        onClick={() => navigate(`/cars/editcar/${car.id}`)}
                        variant="outlined"
                        style={{
                          borderColor: "rgba(233, 174, 49, 0.4)",
                          color: "#E9AE31",
                          borderRadius: "10px",
                          textTransform: "none",
                          fontWeight: 600,
                          fontFamily: "Outfit, sans-serif",
                          padding: "6px 16px",
                          flex: isMidScreen ? 1 : "none"
                        }}
                      >
                        {t("edit")}
                      </Button>
                      <Button
                        onClick={() => handleDeleteClick(car)}
                        variant="outlined"
                        style={{
                          borderColor: "rgba(239, 68, 68, 0.4)",
                          color: "#ef4444",
                          borderRadius: "10px",
                          textTransform: "none",
                          fontWeight: 600,
                          fontFamily: "Outfit, sans-serif",
                          padding: "6px 16px",
                          flex: isMidScreen ? 1 : "none"
                        }}
                      >
                        {t("delete")}
                      </Button>
                    </div>
                  </div>
                </Card>
              );
            })}

            {/* Pagination */}
            {filteredData.length > rowsPerPage && (
              <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop: '24px', gap: '16px' }}>
                <Button
                  disabled={page === 0}
                  onClick={() => setPage(page - 1)}
                  variant="outlined"
                  style={{
                    borderColor: 'var(--border-color)',
                    color: 'var(--text-main)',
                    borderRadius: '8px',
                    textTransform: 'none'
                  }}
                >
                  {t("previous")}
                </Button>
                <Typography style={{ color: 'var(--text-main)', fontWeight: 600 }}>
                  {page + 1} / {Math.ceil(filteredData.length / rowsPerPage) || 1}
                </Typography>
                <Button
                  disabled={page >= Math.ceil(filteredData.length / rowsPerPage) - 1}
                  onClick={() => setPage(page + 1)}
                  variant="outlined"
                  style={{
                    borderColor: 'var(--border-color)',
                    color: 'var(--text-main)',
                    borderRadius: '8px',
                    textTransform: 'none'
                  }}
                >
                  {t("next")}
                </Button>
              </div>
            )}
          </div>
        ) : (
          <Card style={{ padding: '40px', textAlign: 'center', borderRadius: '20px', backgroundColor: 'var(--bg-card)', color: 'var(--text-secondary)', border: 'var(--card-border)' }}>
            <Typography variant="h6" style={{ fontFamily: 'Outfit, sans-serif' }}>
              {t("blank_message") || "No cars found."}
            </Typography>
          </Card>
        )}

        {/* Delete Confirmation Modal */}
        <AlertDialog
          open={deleteConfirmOpen}
          onClose={() => {
            setDeleteConfirmOpen(false);
            setCarToDelete(null);
          }}
        >
          <div style={{ padding: '8px' }}>
            <Typography variant="h6" style={{ fontWeight: 700, fontFamily: 'Outfit, sans-serif', color: 'var(--text-main)', marginBottom: '12px' }}>
              {t("delete_message") || "Are you sure you want to delete this?"}
            </Typography>
            <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '12px', marginTop: '20px' }}>
              <Button
                onClick={() => {
                  setDeleteConfirmOpen(false);
                  setCarToDelete(null);
                }}
                variant="contained"
                style={{ backgroundColor: '#ef4444', color: '#ffffff', borderRadius: '12px', textTransform: 'none', fontWeight: 600 }}
              >
                {t("cancel")}
              </Button>
              <Button
                onClick={() => {
                  if (settings.AllowCriticalEditsAdmin) {
                    dispatch(editCar(carToDelete, "Delete"));
                  } else {
                    alert(t("demo_mode"));
                  }
                  setDeleteConfirmOpen(false);
                  setCarToDelete(null);
                }}
                variant="contained"
                style={{ backgroundColor: '#10b981', color: '#ffffff', borderRadius: '12px', textTransform: 'none', fontWeight: 600 }}
              >
                {t("confirm") || "Confirm"}
              </Button>
            </div>
          </div>
        </AlertDialog>

      <Modal
        disablePortal
        disableEnforceFocus
        disableAutoFocus
        open={profileModal}
        onClose={handleProfileModal}
          className={classes.modal}
          container={() => rootRef.current}
        >
          <Grid
            container
            spacing={1}
            className={classes.paper}
            style={{ direction: isRTL === "rtl" ? "rtl" : "ltr" }}
          >
            <Grid item xs={12} sm={12} md={12} lg={12}>
              <Typography component="h1" variant="h6" style={{ color: 'var(--text-main)', fontFamily: 'Outfit, sans-serif', fontWeight: 600 }}>
                {t("upload_car_image")}
              </Typography>
              <input
                type="file"
                style={{ marginTop: 15, marginBottom: 15, color: 'var(--text-main)', fontFamily: 'Inter, sans-serif' }}
                name={t("image")}
                onChange={(event) => {
                  setSelectedImage(event.target.files[0]);
                }}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={12}>
              {selectedImage && !loading ? (
                <Tooltip title={t("cancel")}>
                  <CancelIcon
                    onClick={() => setSelectedImage(null)}
                    style={{
                      fontSize: 30,
                      backgroundColor: "red",
                      borderRadius: 50,
                      color: "white",
                    }}
                  />
                </Tooltip>
              ) : null}
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={12}>
              {selectedImage ? (
                <img
                  alt="not fount"
                  width={"200px"}
                  height={"200px"}
                  src={URL.createObjectURL(selectedImage)}
                  style={{ marginTop: 15, marginBottom: 20 }}
                />
              ) : (
                <img
                  alt="not fount"
                  width={"200px"}
                  height={"200px"}
                  src={imageData}
                  style={{ marginTop: 10 }}
                />
              )}
              <br />
            </Grid>

            <Grid
              item
              xs={12}
              sm={12}
              md={12}
              lg={12}
              style={{ textAlign: isRTL === "rtl" ? "right" : "left" }}
            >
              {loading ? (
                <Grid
                  container
                  spacing={0}
                  alignItems="center"
                  justify="center"
                  style={{ minHeight: "5vh" }}
                >
                  <CircularProgress />
                </Grid>
              ) : (
                <Grid
                  item
                  xs={12}
                  sm={12}
                  md={12}
                  lg={12}
                  style={{ textAlign: isRTL === "rtl" ? "right" : "left" }}
                >
                  <Button
                    onClick={handleProfileModal}
                    variant="contained"
                    style={{ backgroundColor: '#ef4444', borderRadius: '12px', fontWeight: 600, textTransform: 'none', padding: '8px 24px' }}
                  >
                    {t("cancel")}
                  </Button>
                  <Button
                    onClick={handleSetProfileModal}
                    variant="contained"
                    style={{ marginLeft: 10, backgroundColor: '#10b981', borderRadius: '12px', fontWeight: 600, textTransform: 'none', padding: '8px 24px' }}
                  >
                    {t("save")}
                  </Button>
                </Grid>
              )}
            </Grid>
          </Grid>
        </Modal>
        <AlertDialog open={commonAlert.open} onClose={handleCommonAlertClose}>
          {commonAlert.msg}
        </AlertDialog>
      </div>
    </div>
  );
}
